'use client';

import { useSyncExternalStore } from 'react';

/**
 * Whether the page is on view. An opening splash over the app closes the stage; `useRevealSequence` waits
 * for it to open, so a page whose data lands under the cover still plays its reveal and choreography where
 * the client can see them, instead of finishing behind an opaque logo.
 */
let stageOpen = true;
const listeners = new Set<() => void>();

function setRevealStageOpen(open: boolean): void {
  if (stageOpen === open) return;
  stageOpen = open;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return stageOpen;
}

function getServerSnapshot(): boolean {
  return true;
}

function useRevealStageOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export { setRevealStageOpen, useRevealStageOpen };
